import moment, { Moment } from 'moment';

export type NotificationLevel = 'success' | 'info' | 'warning' | 'error';

export interface NotificationAction {
    label?: string;
    route?: string;
    externalUrl?: string;
    entityId?: string;
    entityType?: string;
}

export interface NotificationReq {
    id?: number;

    title?: string;
    text?: string;
    action?: NotificationAction;
    level?: NotificationLevel;
    source?: string;
    category?: string;
    createdAtUtc?: string | Date | Moment;
    durationMs?: number;

    messages?: string[];
    success?: boolean;
    read?: boolean;
    details?: Record<string, any>;
}

export class CpNotification {
    id?: number;

    title: string;
    messages: string[];
    createdAtUtc: Moment;
    read: boolean;
    success: boolean;

    level?: NotificationLevel;
    action?: NotificationAction;
    details?: Record<string, any>;
    source?: string;
    category?: string;

    constructor(
        title: string,
        messages: string[],
        success: boolean,
        options?: {
            id?: number;
            read?: boolean;
            createdAtUtc?: string | Date | Moment;
            level?: NotificationLevel;
            action?: NotificationAction;
            details?: Record<string, any>;
            source?: string;
            category?: string;
        }
    ) {
        this.id = options?.id;
        this.title = title;
        this.messages = messages;
        this.read = options?.read ?? false;
        this.createdAtUtc = options?.createdAtUtc ? moment(options.createdAtUtc) : moment();
        this.success = success;

        this.level = options?.level;
        this.action = options?.action;
        this.details = options?.details;
        this.source = options?.source;
        this.category = options?.category;
    }
}